// extracted by mini-css-extract-plugin
export default {"dropdown-button":"dropdown-button__KKOtM"};